
import styled from 'styled-components'

export const XO = styled('div')({
  width: 0,
  height: 0
})
